<template>
    <div id="mapViewerContainer">
        <Map ref="mapboxMap" v-bind:mapSpec="mapSpec" :disableSearch="true" :disableLeftPanel="true" :hideOndagoLogo="true"></Map>

        <div class="map-fade" v-if="editedMapObjectId != null"></div>

        <!--<div id="editPanel" class="card" v-if="editedMapObject != null">
            <div class="card-body">
                Edit panel
            </div>
        </div>-->
        <MapObjectEditor class="edit-panel card" v-if="editedMapObjectId != null" v-bind:publisherId="publisherId" v-bind:mapObjectId="editedMapObjectId" v-on:mapObjectSaved="handleMapObjectSaved()" v-on:cancel="handleMapObjectEditionCancelled()" />
        <MapParametersEditor class="edit-panel card" v-if="mapParametersEdited" v-bind:publisherId="publisherId" v-bind:mapId="mapId" v-on:mapParametersSaved="handleMapParametersSaved()" v-on:mapParametersEditionCancelled="handleMapParametersEditionCancelled()" />
    </div>
</template>

<script>
import Map from '@/views/ui/map/Map.vue'
import MapObjectEditor from './MapObjectEditor.vue'
import MapParametersEditor from './MapParametersEditor.vue'
import FromOMBMapSpec from '@/map/spec/FromOMBMapSpec'
import MapService from '@/service/MapService'
import LangUtils from '@/utils/LangUtils';

const mapService = new MapService();

export default {
    components: {
        Map,
        MapObjectEditor,
        MapParametersEditor
    },
    data() {
        return {
            leftPanelItems: [],
            mapSpec: null,
            editedMapObjectId: null,
            publisherId: null,
            mapId: null,
            mapParametersEdited: false
        };
    },
    methods: {
        processObjectSelectionEvent(params) {
            const elementId = params.mapObjectId;
            if (elementId) {
                this.$refs.mapboxMap.selectMapElement(elementId, true);
            }
        },

        handleEditMapParameters() {
            this.mapParametersEdited = true;
        },

        handleEditMapElement(mapElementId) {
            this.editedMapObjectId = mapElementId;
        },

        handleMapElementVisibilityChanged(mapElementId, visible) {
            this.$refs.mapboxMap.setMapElementVisibility(mapElementId, visible);
        },

        handleMapParametersSaved() {
            this.mapParametersEdited = false;
        },

        handleMapParametersEditionCancelled() {
            this.mapParametersEdited = false;
        },

        handleMapObjectSaved() {
            this.editedMapObjectId = null;
        },

        handleMapObjectEditionCancelled() {
            this.editedMapObjectId = null;
        },

        _findMapObjectById(mapObjectId, mapObjects) {
            for (const mapObject of mapObjects) {
                if (mapObjectId == mapObject.getId()) {
                    return mapObject;
                }

                const children = mapObject.getChildren();
                if (children && children.length > 0) {
                    const foundChild = this._findMapObjectById(mapObjectId, children);
                    if (foundChild) {
                        return foundChild;
                    }
                }
            }

            return null;
        }
    },
    watch: {
        leftPanelItems: function(value) {
            this.$root.$emit("admin_left_panel_update", { items: value });
        }
    },
    mounted() {
        this.$root.$emit("admin_left_panel_update", { items: [] });

        this.leftPanelItems = [{
            id: "parameters",
            type: "link",
            name: this.$t('admin.map_detail.parameters'),
            event: {
                id: "onMapParametersSelected"
            }
        }];

        this.publisherId = this.$route.params.publisherId;
        this.mapId = this.$route.params.mapId;
        
        mapService.loadMapForPublisher(this.publisherId, this.mapId).then((map) => {            
            const bundleId = Object.keys(map.getBundleIds())[0];
            this.mapSpec = new FromOMBMapSpec(this.$store.state.currentUser, this.publisherId, bundleId, this.mapId, this.$i18n.locale, this.$i18n, false);
            this.mapSpec.load().then(() => {
                this.$refs.mapboxMap.refresh();

                this.leftPanelItems = [{
                    id: "title",
                    type: "title",
                    name: this.mapSpec.name
                }, {
                    id: "parameters",
                    type: "link",
                    name: this.$t('admin.map_detail.parameters'),
                    event: {
                        id: "onMapParametersSelected"
                    }
                }];

                const layerMapObjects = this.mapSpec.getMapObjectStructure();
                if (layerMapObjects && layerMapObjects.length > 0) {
                    this.leftPanelItems.push({
                        id: "layers",
                        type: "group",
                        name: "??Layers"
                    });

                    for (const layerMapObject of layerMapObjects) {
                        const layerPanelItem = {
                            id: layerMapObject.getId(),
                            type: "expandGroup",
                            name: LangUtils.valueForLanguage(layerMapObject.getName(), this.$i18n.locale),
                            editable: true,
                            visible: true,
                            hideable: true,
                            children: []
                        };

                        const children = layerMapObject.getChildren();
                        if (children && children.length > 0) {
                            for (const child of children) {
                                const childPanelItem = {
                                    id: child.getId(),
                                    type: "link",
                                    editable: true,
                                    hideable: true,
                                    event: {
                                        id: "onObjectSelected",
                                        params: {
                                            mapObjectId: child.getId()
                                        }
                                    },
                                    name: LangUtils.valueForLanguage(child.getName(), this.$i18n.locale),
                                    visible: true
                                }
                                layerPanelItem.children.push(childPanelItem);
                            }
                        }

                        this.leftPanelItems.push(layerPanelItem);
                    }
                }
            }).catch(() => {
                // TODO
            });
        }).catch(() => {
            // TODO Handle error
        });

        this.$root.$on("onObjectSelected", (data) => {
            this.processObjectSelectionEvent(data);
        });

        this.$root.$on("onMapParametersSelected", () => {
            this.handleEditMapParameters();
        })

        this.$root.$on("onLeftPanelEditClicked", (data) => {
            this.handleEditMapElement(data.id);
        });

        this.$root.$on("onLeftPanelHiddenSwitchClicked", (data, visible) => {
            this.handleMapElementVisibilityChanged(data.id, visible);
        });
    }
}
</script>

<style scoped>
#mapViewerContainer {
    position: relative;
    width: 100%;
    height: 100%;
}

.map-fade {
    background: #00000055;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
}

.edit-panel {
    position: absolute;
    top: 20px;
    left: calc(50% - 35%);
    width: 70%;
    height: 70%;
}
</style>